import {
  type EditorValue,
  type SerializedPlate,
  serializePlate,
  serializeToText,
} from '@octopus-do/octopus-editor'

import { getInlineContext } from './getInlineContext'
import { isEditorValue } from './isEditorValue'

type Content = string | null | undefined
type BlockContent = EditorValue | Content

export const getBlockContentText = (content: BlockContent): string => {
  if (isEditorValue(content)) {
    return serializeToText(content)
  }

  return getInlineContext(content)
}

export const getBlockContent = (
  content: BlockContent
): string | null | undefined | SerializedPlate[] => {
  if (isEditorValue(content)) {
    return serializePlate(content)
  }

  return content
}
